<template>
    <div class="">

      <el-input
       placeholder="Find by user"
       debounce=100
       v-model="userQuery">
       <i slot="prefix" class="el-input__icon el-icon-search"></i>
     </el-input>
     <el-button style="width:100%; margin: 5px 0px" @click="findUser" type="warning">Find User</el-button>
     <el-button style="width:100%; margin-left: unset" type="primary" @click="gotoCreateUser"> Create User account </el-button>

      <div class="users--items">
        <el-card class="box-card"
          v-for="(user, index) in users"
          :key="index">
          <div slot="header" class="clearfix">
            <span>{{`${user.first_name}  ${user.last_name}`}}</span>
            <el-button style="float: right; padding: 5px 5px" type="danger">Block</el-button>
          </div>
          <div >
            <div class="text item">{{user.email}}</div>
            <div class="text item">{{user.username}}</div>
            <div class="text item">{{user.user_type.toUpperCase()}}</div>
            <div class="text item">{{user.address}}</div>
          </div>

        </el-card>
      </div>
    </div>
</template>

<script>
import { getUsers, searchUser } from '@/services/user'
export default {
  name: 'UserAdmin',
  data () {
    return {
      users: [],
      userQuery: null
    }
  },
  mounted () {
    this.loadUsers()
  },

  methods: {
    loadUsers () {
      getUsers('users_admin')
        .then(res => {
          this.users = res.data
        })
    },

    findUser (event) {
      searchUser(this.userQuery)
        .then(res => {
          this.users = res.data
        })
    },

    gotoCreateUser () {
      this.$router.push({ name: 'UserAddEdit' })
    }
  }
}
</script>

<style lang="scss" scoped>

.users--items {
  margin-top: 10px;
}
.text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/users/UserAdmin.vue